import { Component } from '@angular/core';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';

@Component({
  selector: 'mcp-user-menu',
  templateUrl: './user-menu.component.html',
})
export class UserMenuComponent {
  returnUrlParam = '?returnUrl=';

  get isSSOUser(): boolean {
    return this.context.instance?.isSSO || false;
  }

  get userName(): string {
    const userNameWithDomain = this.context.instance?.username || '';
    if (userNameWithDomain.indexOf('\\') > 0) return userNameWithDomain.split('\\')[1];
    return userNameWithDomain;
  }

  onUpdateProfile(): void {
    const url = this.getRedirectUrl(this.context.instance.userProfileUrl);
    this.window.location.href = `${url}`;
  }

  onChangePassword(): void {
    const url = this.getRedirectUrl(this.context.instance?.changePasswordUrl);
    this.window.location.href = `${url}`;
  }

  private getRedirectUrl(location: string): string {
    const currentUrl = this.getCurrentUrl();
    return `${location}${this.returnUrlParam}${currentUrl}`;
  }

  private getCurrentUrl(): string {
    return encodeURIComponent(this.window.location.href);
  }

  constructor(private window: Window, private context: ContextService) {
  }
}
